import { createStorage } from 'typesafe-storage';
export var storage = createStorage(localStorage);
